import React from 'react';
import PropTypes from 'prop-types';
import { getData } from 'country-list';
import './country-field.css';

const CountryField = (props) => {
  const countries = getData().sort((c1, c2) => c1.name.localeCompare(c2.name));

  function open() {
    document.body.classList.add('disable-scroll');
    props.open(true);
  }

  function close() {
    document.body.classList.remove('disable-scroll');
    props.open(false);
  }

  function change(countryCode) {
    close();
    props.onChange(countryCode);
  }

  const country = countries.find(country => country.code === props.value);

  return (
    <>
      <div onClick={ open } id="country-field-container">
        <label>Country / Region*</label>
        <div className="select-menu">{country.name}</div>
      </div>
      <div
        onClick={ close }
        className={ props.isOpen ? 'options-screen open' : 'options-screen' }
      >
        <div className="options-holder">
          {countries.map(country => (
            <div
              // eslint-disable-next-line react/jsx-no-bind
              onClick={ () => change(country.code) }
              key={ country.code }
              className="select-option"
            >
              {country.name}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

CountryField.propTypes = {
  onChange: PropTypes.func,
  isOpen: PropTypes.bool,
  open: PropTypes.func,
  value: PropTypes.string
};

export default CountryField;